import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RightContainer = styled("div")<{ modalStyling?: boolean }>(({ theme, modalStyling }) => ({
   backgroundColor: theme.colors["neutral.900"],
   borderBottomRightRadius: '1rem',
   height: '100%',
   position: 'relative',
   color: theme.colors["neutral.300"],
   overflow: 'hidden',
   "&:after": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' :'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(9,9,9,1) 130%)',
      width: '10rem',
      position: 'absolute',
      right: '0',
      top: '0',
      height: '100%',
      pointerEvents: 'none',

      "@media (max-width: 600px)": {
         background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' :'linear-gradient(90deg, rgba(255,255,255,0) 60%, rgba(9,9,9,0.8) 130%)',
      }
   },
   "&:before": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 100%)',
      position: 'absolute',
      pointerEvents: 'none',
      left: '0',
      top: '0',
      transition: 'opacity ease-in-out .3s',
      height: '100%',
      width: '10rem',
      opacity: '0',
      zIndex: '1',

      "@media (max-width: 600px)": {
         background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 30%)',
      }
   },
   "&.shadow": {
      "&:before": {
         content: '""',
         opacity: '1'
      },
   },
}));

export const SpinnerContainer = styled("div")(({ theme }) => ({
   display: "flex",
   height: "100%",
   justifyContent: "center",
   alignItems: "center",
   paddingBottom: "4rem",
   color: theme.colors["neutral.200"]
}));

export const OverflowControl = styled("div")(({ theme }) => ({
   position: 'absolute',
   width: '100%',
   transition: 'all .8s cubic-bezier(.33,.4,0,.96)',
}));

export const ErrorTooltipContainer = styled("div")(({ theme }) => ({
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   color: theme.colors["red.500"],
   fontSize: theme.fontSizes.xs,
   fontFamily: theme.fonts.default,
}));

export const WarningTooltipContainer = styled("div")(({ theme }) => ({
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   color: theme.colors["yellow.400"],
   fontSize: theme.fontSizes.xs,
   fontFamily: theme.fonts.default,
}));

export const TableBodyRow = styled("div")<{ isHighlighted: boolean }>(({ theme, isHighlighted }) => ({
   display: 'grid',
   gridAutoFlow: 'column',
   height: '60px',
   justifyContent: 'space-evenly',
   paddingLeft: '1rem',
   border: isHighlighted ? `2px solid ${theme.colors["blue.500"]}` : 'none',
   borderLeft: "none",
   transition: "border 200ms ease-in-out",

   "&:nth-of-type(odd)": {
      backgroundColor: theme.colors["neutral.950"],
      ".cell": {
         backgroundColor: theme.colors["neutral.950"],
      },
   },

   "@media (max-width: 600px)": {
      height: "70px",
   },
}));

export const TableBodyCell = styled("div")(({ theme }) => ({
   width: '112px',
   display: 'grid',
   padding: '0.4rem 0.5rem 0 0.5rem',
   alignItems: 'center',
   justifyContent: 'center',
   gridTemplateRows: 'auto 16px',
   gridTemplateColumns: "1fr",
   position: 'relative',
  

    '&:hover [data-slot="input"]': {
      background: theme.colors["neutral.950"],
   },
  
    '&:hover [data-slot="root"]': {
      border: `1px solid ${theme.colors["neutral.700"]}`,
      boxShadow: `0 2px 4px ${theme.colors["neutral.950"]}`,
      opacity: 1,
    },

    '[data-slot="incrementButton"], [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 0,
      transition: 'all 0.3s ease',
    },
  
    '&:hover [data-slot="incrementButton"], &:hover [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 1,
    },
}));

export const TotalTickets = styled(Typography)(({ theme }) => ({
  fontSize: theme.fontSizes.lg,
  fontFamily: theme.fonts.default,
  color: theme.colors["neutral.50"],
  fontWeight: theme.fontWeights.bold,
  textAlign: 'center'
}));

export const Value = styled(Typography)(({ theme }) => ({
   marginTop: '12px',
   width: '100px',
   color: theme.colors["neutral.50"],
   fontSize: theme.fontSizes.lg,
   fontFamily: theme.fonts.default,
   textAlign: 'center',
   position: 'relative'
}));

export const EmptyTitle = styled(Typography)(({ theme }) => ({
   color: theme.colors["neutral.50"],
   fontSize: theme.fontSizes["2xl"],
   fontWeight: theme.fontWeights.bold,
   fontFamily: theme.fonts.default,
}));
export const EmptyMessage = styled(Typography)(({ theme }) => ({
   color: theme.colors["neutral.500"],
   fontSize: theme.fontSizes.lg,
   fontFamily: theme.fonts.default,
   margin: '1rem 0',
   maxWidth: '40rem',
   textAlign: 'center'
}));